import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointMsa = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };

  return (
    <>
      {context.state["Carriere" + ClientConjoint].filter((Carriere) => Carriere.Nature === "Msa").length > 0 && (
        <>
          <div className="card">
            <div className="category-column">MSA proportionnelle</div>
            <div className="value-column">
              <TextField
                value={context.state["TableauPoints" + ClientConjoint].RetraiteProportionnelleMsa}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "RetraiteProportionnelleMsa", e);
                }}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            </div>
            <div className="value-column">
              <DropDown
                value={context.state["TableauPoints" + ClientConjoint].AnneeFinMsaProp}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "AnneeFinMsaProp", e);
                  props.CalculRetraite();
                }}
                options={[
                  { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                  { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
                ]}
                normal
              />
            </div>
            <div className="value-column">
              <TextField
                value={resultRetraite?.InfosRetraite?.Msa?.General?.PointPropCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Msa?.General?.PointPropCalcule}
                disabled={true}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            </div>
          </div>
          <div className="card">
            <div className="category-column">MSA RCO</div>
            <div className="value-column">
              <TextField
                value={context.state["TableauPoints" + ClientConjoint].RetraiteCompMsa}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "RetraiteCompMsa", e);
                }}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            </div>
            <div className="value-column">
              <DropDown
                value={context.state["TableauPoints" + ClientConjoint].AnneeFinMsaComp}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "AnneeFinMsaComp", e);
                  props.CalculRetraite();
                }}
                options={[
                  { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                  { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
                ]}
                normal
              />
            </div>
            <div className="value-column">
              <TextField
                value={resultRetraite?.InfosRetraite?.Msa?.General?.PointCompCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Msa?.General?.PointCompCalcule}
                disabled={true}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default PointMsa;
